import { render } from "./Contato.vue?vue&type=template&id=7addcbda&scoped=true&lang=pug"
import script from "./Contato.vue?vue&type=script&setup=true&lang=js"
export * from "./Contato.vue?vue&type=script&setup=true&lang=js"

import "./Contato.vue?vue&type=style&index=0&id=7addcbda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7addcbda"]])

export default __exports__